import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import AgencyInfo from "./AgencyInfo";
import "./ViewAgency.css";

// Header banner — copied structure/classes 1:1 from ViewIncident.js's
// header (plain div, no GridStack row) so it sizes to its own two-line
// title+subtitle content instead of being clipped by a fixed grid-row
// height, which is what caused the subtitle to overlap the card below.
const ViewAgency = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const agencyData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="agv-header-banner">
        <button type="button" className="agv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="agv-header-icon">
          <Building2 size={14} color="#fff" />
        </span>
        <div>
          <div className="agv-header-title">View Agency</div>
          <div className="agv-header-subtitle">Partner agency details and contact information</div>
        </div>
      </div>
      <AgencyInfo agencyData={agencyData} />
    </div>
  );
};

export default ViewAgency;
